import React, { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router';
import { urlAdminPage, urlFirstPage, urlSecondPage } from '../Components/Utils/globalVariables';
import ScrollToTop from '../Components/Utils/ScrollToTop';
import { ProtectedRoute, UnProtectedRoute } from './ProtectedRoute';
import HomePage from '../Pages/HomePage';
import TopMenu from '../Components/View/Menus/TopMenu';
import { Paper, Stack, styled } from '@mui/material';
import AdminPage from '../Pages/AdminPage';

export default function MyRouter() {

    const AppContainer = styled(Stack)(
        ({ theme }) => `
            max-width: 1320px;
            margin: 0 auto;
        `
    )

    return (
        <ScrollToTop>
            <AppContainer spacing={4}>
                <Routes>
                    <Route children="/*">
                        <Route path={urlFirstPage} index element={<HomePage />} />
                        <Route path={urlAdminPage} index element={<AdminPage />} />
                    </Route>
                    {/* <Route path="/*" element={<NotFoundPage />} /> */}
                </Routes> 
            </AppContainer>
        </ScrollToTop>
    );
}